var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"target-view",staticClass:"target-preview-inside cat-trans",attrs:{"id":"source-view"},domProps:{"innerHTML":_vm.xss(_vm._s(_vm.getTargetContentInfo.convertStr))}})}
var staticRenderFns = []

export { render, staticRenderFns }